import { ReactElement, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, Row, Col, Alert, Button } from "antd";
import { v4 as uuidv4 } from "uuid";
import firebase from "firebase/app";
import { InstagramOutlined, MailOutlined } from "@ant-design/icons";
import { CREATE_BOOKING_REQUEST, LOGIN_USER_FAILURE, LOGIN_USER_REQUEST, CHNAGE_LANGUAGE } from "../../redux/constants";
import { getAuthState, getBookingState, getAppState } from "../../redux/selectors";
import { FormCol, FormInput, FormButton, NavigateBar, NavigateButton } from "../../components/GlobalStyles";
import Logo from "../../assets/images/setpoint-logo.png";
import backgroundImage from "../../assets/images/setpoint-landing.png";
import api from "../../redux/api/axiosInstance";
import Loading from "../../components/Loading";

export function Login(): ReactElement {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { currentUser, emailVerified } = useSelector(getAuthState);
  const { isShareBooking, shareBookingTime, shareBookingDuration, shareBookingCourt, preBranch, preBookingDate } = useSelector(getBookingState);
  const { locale } = useSelector(getAppState);

  const [email, setEmail] = useState<string>();
  const [password, setPassword] = useState<string>();
  const [error, setError] = useState<string>("");
  const [errorMsg, setErrorMsg] = useState<string>("");
  const [showError, setShowError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [userCount, setUserCount] = useState<number>(0);

  const goRegister = () => {
    history.push("/register");
  };

  const goLoginPhone = () => {
    history.push("/login_with_phone");
  };

  const bookIfNeeded = () => {
    // Create new booking with Share data
    const newBooking = {
      bookingId: uuidv4(),
      userId: currentUser?.id,
      branchId: preBranch?.firestoreRef,
      courtId: shareBookingCourt,
      date: preBookingDate,
      period: shareBookingDuration,
      start: shareBookingTime,
      end: "",
      ball: false,
      club: preBranch?.clubData.firestoreRef,
      note: "",
      price: preBranch?.clubData.price[shareBookingDuration],
      currency: preBranch?.clubData.currency,
    };
    dispatch({
      type: CREATE_BOOKING_REQUEST,
      payload: { data: newBooking },
    })
  };

  const loginFn = () => {
    if (email && password) {
      setError("");
      setErrorMsg("");
      setShowError(false);
      setLoading(true);
      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(async (result) => {
          if (result.user?.emailVerified) {
            dispatch({
              type: LOGIN_USER_REQUEST,
              payload: {
                user: result.user,
                emailVerified: true,
                authType: "email",
              },
            });
          } else {
            result.user?.sendEmailVerification();
            setLoading(false);
            history.push("/email_verify");
          }
        })
        .catch((err) => {
          dispatch({
            type: LOGIN_USER_FAILURE,
            payload: { error: true, errorMsg: err.message },
          });
          setError(err.code);
          setErrorMsg(err.message);
          setShowError(true);
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    firebase.auth().useDeviceLanguage();
    api.post("getUserCount").then((res) => {
      const { users } = res.data;
      setUserCount(users);
      setLoading(false);
    });
  }, [])

  useEffect(() => {
    if (currentUser && emailVerified) {
      setLoading(false);
      if (isShareBooking) { bookIfNeeded(); }
      if (currentUser.role === "regular") { history.push("/booking"); }
      else if (currentUser.role === "manager" || currentUser.role === "admin") {
        history.push("/dashboard");
      }
    }
  }, [currentUser]);

  const onChangeLanguage = (code: string) => {
    dispatch({
      type: CHNAGE_LANGUAGE,
      payload: code
    })
    i18n.changeLanguage(code);
  }


  return (
    <Row className="auth-container" style={{ alignItems: "flex-start" }}>
      <div className="landing-language-select-container" style={{ zIndex: 20 }}>
        {/* <Button className="language-selector" onClick={() => history.push("/shop")}>{t("menu.shop")}</Button> */}
        <Button className="language-selector" onClick={() => onChangeLanguage(locale === "en" ? "ar" : "en")}>{t("common.language")}</Button>
        {/* <Button className="language-selector" onClick={() => history.push("/login")}>{t("menu.login")}</Button> */}
      </div>
      <div className="landing-container">
        <div className="section">
          <img src={backgroundImage} alt="" className="top-section-background-image" />
          <div className="top-section-title-container">
            <img src={Logo} alt="Logo" className="auth-logo" style={{ marginTop: 20 }} />
            {/* <h2 className="top-section-title">{t("auth.welecome_community")}</h2> */}
            {/* <p className="top-section-sub-title">{t("auth.find_your_slot")}</p> */}
          </div>
        </div>
        <Row style={{ marginTop: 20 }} gutter={8} className="section">
          {/* <Col sm={24} md={12} className="sigin-count-section">
            <div style={{textAlign: "center"}}>
              <h4 style={{ fontSize: 32, margin: 0, color: "#fff"}}>{t("auth.sigin-ins")}</h4>
              <h2 style={{ fontSize: 64, margin: 0, color: "#fff", fontWeight : 700 }}>{userCount}</h2>
              <h6 style={{ fontSize: 24, margin: 0, color : "#fff"}}>{t("auth.dont_be_left_out")}</h6>
            </div>
          </Col> */}
          <Col sm={24} md={24}>
            <Row className="sigin-description-section">
              <Col span={24} style={{ textAlign: "center" }}>
                <span style={{ width: "100%", fontSize: 16, color: "#eee" }}>{t("auth.login_to")}</span>
              </Col>
              <Col span={24} style={{ textAlign: "center", marginTop: 8, marginBottom: 8 }}>
                <span style={{ fontSize: 16, color: "#eee" }}>{t("auth.view_all_vacant_slot_here")}</span>
              </Col>
            </Row>
            <Row className="section">
              <Card className="auth-form" style={{ maxWidth: 360 }}>
                <FormCol span={24}>
                  <FormInput
                    placeholder={t("auth.email")}
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    onPressEnter={loginFn}
                  />
                  <FormInput
                    placeholder={t("auth.password")}
                    type="password"
                    value={password}
                    onChange={(event) => setPassword(event.target.value)}
                    onPressEnter={loginFn}
                  />
                  <a href="/forget_password" className="forget_password_link">
                    {t("auth.forget_password")}
                  </a>
                  <FormButton type="primary" block onClick={loginFn} loading={loading}>
                    {t("auth.login")}
                  </FormButton>
                  {/* <FormButton
                    type="primary"
                    block
                    onClick={goLoginPhone}
                    style={{ marginTop: "5px" }}
                  >
                    {t("auth.register_with_phone")}
                  </FormButton> */}
                  {showError && <Alert message={errorMsg} type="error" style={{ width: "100%", marginTop: 10 }} />}
                  <NavigateBar>
                    <span style={{ color: "#fff" }}>{t("auth.noAccount")}</span>
                    <NavigateButton type="link" onClick={goRegister}>
                      {t("auth.register")}
                    </NavigateButton>
                  </NavigateBar>
                </FormCol>
              </Card>
            </Row>
          </Col>
        </Row>
      </div>
      <div className="contact-us-container">
        {/* <span>{t("menu.contact_us")}: </span>
        <span></span>
        <a href="mailto:hi@setpointapp.com" target="_blank" rel="noreferrer">hi@setpointapp.com</a> */}

        <Button href="mailto:hi@setpointapp.com" type="link" icon={<MailOutlined />} target="_blank">hi@setpointapp.com</Button>
        <Button href="https://www.instagram.com/setpointapp/" type="link" icon={<InstagramOutlined />} target="_blank">Instagram</Button>

      </div>
      {loading && <Loading />}
    </Row>
  );
}
